<template>
  <f7-page name="program-info">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        프로그램 정보
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>
		<f7-block-title>프로그램</f7-block-title>
		<div class="list">
			<ul>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">프로그램 버젼</div>
							<div class="item-after">{{programVersion()}}</div>
						</div>
					</div>
				</li>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">운영체제</div>
							<div class="item-after">{{osName()}}</div>
						</div>
					</div>
				</li>
				<li>
					<div class="item-content">
						<div class="item-inner">
							<div class="item-title">크롬 브라우저</div>
							<div class="item-after">{{checkChromeBrowser()}}</div>
						</div>
					</div>
				</li>
				<li>
					<a href="#" class="item-link item-content" v-on:click="install">
						<div class="item-inner">
							<div class="item-title">홈화면 단축아이콘 생성</div>
						</div>
					</a>
				</li>
				<li>
					<a href="/license-info" class="item-link item-content">
						<div class="item-inner">
							<div class="item-title">license infomation</div>
						</div>
					</a>
				</li>
			</ul>
		</div>
  </f7-page>
</template>

<script>
import MODULE from '../../js/common/module';
import Vue from 'vue';
import PAGES from '../../js/pages';
import CONST from '../../js/common/constant';
import API from '../../js/common/api';
import AUTH from '../../js/common/auth';

export default {
  data() {
    return {
      installed: false
    }
  },
  mounted() {
    var _this = this;

		_this.installed = window.appInstalled;
  },
  methods: {
    programVersion() {
			return this.$f7.params.name + " " + this.$f7.params.version;
		},
		checkChromeBrowser() {
			if (MODULE.Util.isChromeBrowser()) {
				return "Chrome Browser";
			}

			return "NONE Chrome Browser";
		},
		osName() {
			return MODULE.Util.getOSName();
		},
		install() {
			var _this = this;

			const promptEvent = window.deferredPrompt;
			if (!promptEvent){
				MODULE.DialogBox.message("이미 생성되어있습니다.");
				console.log('beforeinstallprompt 미발생.');
				return;
			}
			
			promptEvent.prompt();

			promptEvent.userChoice.then((choiceResult) => {
				if (choiceResult.outcome === 'accepted') {
					_this.installed = true;
					window.deferredPrompt = null;

					MODULE.DialogBox.message("단축 아이콘이 생성되었습니다.<br/>홈 화면을 확인하세요.");
				} else {
					console.log('사용자 설치 취소.');
				}
			});
		}
  }
}

</script>